import angular from 'angular';

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:AppsoupHttpInterceptor
 * @description
 * Http interceptor for all Appsoup $http calls
 */
const httpInterceptorModule = angular.module('appsoup.httpInterceptor', []);

httpInterceptorModule.factory('AppsoupHttpInterceptor', ['$rootScope', '$q', 'growl', function ($rootScope, $q, growl) {
    'use strict';
    return {
        'request': function (config) {
            try {
                if (window && window.location && window.location.protocol === 'https:' && typeof config.url === 'string') {
                    if (config.url.indexOf('http://') === 0) {
                        config.url = 'https://' + config.url.substring('http://'.length);
                    }
                }
            } catch (e) {}

            return config;
        },
        'requestError': function (rejection) {
            return $q.reject(rejection);
        },
        'responseError': function (rejection) {
            if (angular.isDefined(rejection.status)) {
                var errorMsg = '';
                switch (rejection.status) {
                    case 400:
                        errorMsg = 'ERROR.HTTP.400';
                        break;
                    case 401:
                        errorMsg = 'ERROR.HTTP.401';
                        $rootScope.$broadcast('userNotLoggedIn');
                        break;
                    case 403:
                        errorMsg = 'ERROR.HTTP.403';
                        $rootScope.$broadcast('userNotLoggedIn');
                        break;
                    case 404:
                        // errorMsg = 'ERROR.HTTP.404';
                        $rootScope.$broadcast('404');
                        break;
                    case 413:
                        errorMsg = 'ERROR.HTTP.413';
                        break;
                    case 500:
                        errorMsg = 'ERROR.HTTP.500';
                        break;
                    case 504:
                        errorMsg = 'ERROR.HTTP.504';
                        break;
                    default:
                        /* eslint-disable-next-line */
                        console.error('ERROR not handled yet!', rejection);
                }
                if (errorMsg !== '') {
                    growl.error(errorMsg);
                }
            }

            return $q.reject(rejection);
        }
    };
}]);

export default httpInterceptorModule;
